import type { z } from 'zod';
import { EngineAtomSearchSchema } from './engine-atom-search-schema';

/**
 * Attendance logic components 一覧専用 search。
 *
 * 一覧に lifecycle タブ UI が無く、`lifecycleTab` を選ぶ手段が存在しないため、
 * `EngineAtomSearchSchema` から `lifecycleTab` を除いた形にする
 * （持たせたままだと既定値 'applied' で絞り込まれ、draft/archived を見る手段も
 *  URL 直打ちから復帰する手段も無くなる）。他ルートは `EngineAtomSearchSchema` を
 *  引き続き使うため、共有スキーマ自体は変更しない。
 */
export const AttendanceLogicComponentListSearchSchema = EngineAtomSearchSchema.omit({
  lifecycleTab: true
});
export type AttendanceLogicComponentListSearchParams = z.infer<typeof AttendanceLogicComponentListSearchSchema>;